(function () {
  'use strict';

  /* Platzhalter [grafik:name] im Artikeltext durch die Grafik ersetzen ------ */
  document.querySelectorAll('.prose p').forEach(function (p) {
    var m = p.textContent.trim().match(/^\[grafik:([a-z0-9-]+)\]$/i);
    if (!m) return;
    var tpl = document.getElementById('kb-fig-' + m[1].toLowerCase());
    if (tpl) p.replaceWith(tpl.content.cloneNode(true)); else p.remove();
  });
  // Im Shopify-Theme laufen die Reveal-Animationen über fothermo.js; neu eingefügte Elemente sofort zeigen
  document.querySelectorAll('.prose .reveal, .prose .reveal-scale').forEach(function (el) { el.classList.add('is-visible'); });

  function onVisible(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { fn(); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(el);
  }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.classList.contains('mockup');

  /* Übersicht: Kategorie-Filter ---------------------------------------------- */
  var filter = document.querySelector('.kb-filter');
  if (filter) {
    var items = document.querySelectorAll('[data-cat]');
    var apply = function (cat) {
      filter.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.filter === cat)); });
      items.forEach(function (it) { it.hidden = cat !== 'alle' && it.dataset.cat !== cat; });
    };
    filter.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        apply(b.dataset.filter);
        try { history.replaceState(null, '', b.dataset.filter === 'alle' ? location.pathname : '?kat=' + b.dataset.filter); } catch (e) {}
      });
    });
    var start = new URLSearchParams(location.search).get('kat');
    apply(filter.querySelector('[data-filter="' + start + '"]') ? start : 'alle');
  }

  /* Zähler, die beim Sichtbarwerden hochlaufen ------------------------------ */
  document.querySelectorAll('[data-count]').forEach(function (el) {
    var target = parseFloat(el.dataset.count), prefix = el.dataset.prefix || '', suffix = el.dataset.suffix || '';
    var fmt = function (v) { return prefix + Math.round(v).toLocaleString('de-DE') + suffix; };
    if (reduced) { el.textContent = fmt(target); return; }
    el.textContent = fmt(0);
    onVisible(el, function () {
      var t0 = null, dur = 1400;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * e);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  });

  /* Modul-Rechner ----------------------------------------------------------- */
  var cfg = document.querySelector('[data-config]');
  if (cfg) {
    var MODELS = {
      'rod-1000': { name: '1 kW Solarheizstab', min: 1500, max: 2500 },
      'rod-550': { name: '550 W Solarheizstab', min: 800, max: 1600, limit: 2000, limitCount: 5 }
    };
    var state = { model: 'rod-1000', wp: 430, count: 4 };
    var range = cfg.querySelector('input[type="range"]');
    var nf = function (n) { return n.toLocaleString('de-DE'); };

    function render() {
      var m = MODELS[state.model], total = state.wp * state.count;
      cfg.querySelectorAll('.config__panel').forEach(function (p, i) { p.classList.toggle('is-on', i < state.count); });
      cfg.querySelectorAll('.config__wire').forEach(function (w, i) {
        if (w.dataset.i === undefined) w.dataset.i = i;
        w.classList.toggle('is-on', +w.dataset.i < state.count);
      });
      // Aktive (grüne) Leitungen nach oben legen, damit graue sie nicht überdecken
      var trunk = cfg.querySelector('.config__trunk');
      cfg.querySelectorAll('.config__wire.is-on').forEach(function (w) { w.parentNode.insertBefore(w, trunk); });
      if (trunk) trunk.parentNode.insertBefore(trunk, trunk.parentNode.querySelector('.config__panel'));
      cfg.querySelector('[data-out="count"]').textContent = state.count + (state.count === 1 ? ' Modul' : ' Module');
      cfg.querySelector('[data-out="total"]').textContent = nf(total) + ' Wp';
      var v = cfg.querySelector('.config__verdict'), txt, st;
      if (m.limit && (total > m.limit || state.count > m.limitCount)) {
        st = 'max'; txt = 'Zu viel: Der 550 W Solarheizstab verträgt maximal ' + nf(m.limit) + ' Wp mit bis zu ' + m.limitCount + ' Modulen.';
      } else if (total < m.min) {
        st = 'low'; txt = 'Unter der Empfehlung (' + nf(m.min) + '–' + nf(m.max) + ' Wp). Funktioniert, heizt aber langsamer.';
      } else if (total > m.max) {
        st = 'high'; txt = 'Über der Empfehlung (' + nf(m.min) + '–' + nf(m.max) + ' Wp). Sprich uns vorher kurz an.';
      } else {
        st = 'ok'; txt = 'Passt: im empfohlenen Bereich für den ' + m.name + ' (' + nf(m.min) + '–' + nf(m.max) + ' Wp).';
      }
      v.dataset.state = st;
      v.querySelector('span').textContent = txt;
    }
    cfg.querySelectorAll('[data-set]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.dataset.set;
        state[key] = key === 'wp' ? +b.dataset.value : b.dataset.value;
        cfg.querySelectorAll('[data-set="' + key + '"]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        render();
      });
    });
    range.addEventListener('input', function () { state.count = +range.value; render(); });
    render();
  }

  /* Tagesablauf im Speicher ------------------------------------------------- */
  var day = document.querySelector('[data-day]');
  if (day) {
    var STEPS = [
      { temp: 38, sun: 0.35, sunY: 70, flame: false, state: 'Heizung wartet', color: '#9fd3ef' },
      { temp: 58, sun: 1, sunY: 0, flame: false, state: '1 kW Solarheizstab heizt mit Sonnenstrom', color: '#ffb877' },
      { temp: 65, sun: 0.8, sunY: 30, flame: false, state: 'Ziel erreicht – Rod stoppt', color: '#ff9a4d' },
      { temp: 42, sun: 0.15, sunY: 40, flame: true, state: 'Heizung springt ein', color: '#c6e3f2' }
    ];
    var buttons = day.querySelectorAll('.day__step'), idx = 0, timer = null;
    var fill = day.querySelector('.tank-fill'), temp = day.querySelector('.temp'), label = day.querySelector('.state');
    var flame = day.querySelector('.flame'), sun = day.querySelector('.sun');
    var TOP = 70, BOTTOM = 290;
    function show(i) {
      idx = i;
      var s = STEPS[i], h = (BOTTOM - TOP) * (s.temp - 10) / 60;
      fill.setAttribute('y', BOTTOM - h);
      fill.setAttribute('height', h);
      fill.style.fill = s.color;
      temp.textContent = s.temp + ' °C';
      label.textContent = s.state;
      label.style.fill = s.flame ? '#b3561d' : '#3d752f';
      flame.style.opacity = s.flame ? 1 : 0.12;
      sun.style.opacity = s.sun;
      sun.style.transform = 'translateY(' + s.sunY + 'px)';
      buttons.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
    }
    buttons.forEach(function (b, j) {
      b.addEventListener('click', function () { clearInterval(timer); timer = null; show(j); });
    });
    show(0);
    if (!reduced) onVisible(day, function () {
      timer = setInterval(function () { show((idx + 1) % STEPS.length); }, 3200);
    });
  }


  /* MPP-Tacho 1 kW Solarheizstab ---------------------------------------------------------
     Rechenweg: Heizleistung P = Vmpp × maximaler Eingangsstrom, begrenzt auf die Nennleistung.
     Werte hier anpassen: */
  var GAUGE = {
    iMax: 23,        // maximaler Strom in A
    pMax: 1000,      // Nennleistung 1 kW Solarheizstab in W
    vLimit: 50,      // Skalenende (MPP-Spannung). Die Grenze von 50 V gilt für die Leerlaufspannung Voc, nicht für Vmpp
    vMin: 20,        // Skala von …
    vMax: 50,        // … bis
    vStart: 40       // Startwert
  };
  var gBox = document.querySelector('[data-gauge]');
  if (gBox) {
    var svgG = gBox.querySelector('svg');
    var CX = 200, CY = 205, RAD = 150;
    var vFull = GAUGE.pMax / GAUGE.iMax;
    var fmt = function (v, d) { return v.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }); };
    var ang = function (v) { return Math.PI * (1 - (v - GAUGE.vMin) / (GAUGE.vMax - GAUGE.vMin)); };   // π (links) … 0 (rechts)
    var pt = function (v, r) { var a = ang(v); return [CX + r * Math.cos(a), CY - r * Math.sin(a)]; };
    var arc = function (v1, v2, r) {
      var p1 = pt(v1, r), p2 = pt(v2, r);
      return 'M' + p1[0].toFixed(1) + ' ' + p1[1].toFixed(1) + ' A' + r + ' ' + r + ' 0 0 1 ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    };
    // Skala zeichnen
    var ns = 'http://www.w3.org/2000/svg', scale = svgG.querySelector('.gauge__scale');
    function el(tag, attrs, parent) { var e = document.createElementNS(ns, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); (parent || scale).appendChild(e); return e; }
    el('path', { d: arc(GAUGE.vMin, GAUGE.vMax, RAD), fill: 'none', stroke: '#e3e6ea', 'stroke-width': 26 });
    el('path', { d: arc(GAUGE.vMin, vFull, RAD), fill: 'none', stroke: 'url(#gaugePart)', 'stroke-width': 26 });
    el('path', { d: arc(vFull, GAUGE.vLimit, RAD), fill: 'none', stroke: '#3d752f', 'stroke-width': 26 });
    el('path', { d: arc(GAUGE.vLimit, GAUGE.vMax, RAD), fill: 'none', stroke: '#d64535', 'stroke-width': 26 });
    for (var t = GAUGE.vMin; t <= GAUGE.vMax; t += 1) {
      var major = t % 5 === 0, o = pt(t, RAD - 18), i = pt(t, RAD - (major ? 30 : 24));
      el('line', { x1: o[0], y1: o[1], x2: i[0], y2: i[1], class: 'gauge__tick' + (major ? ' gauge__tick--major' : '') });
      if (major) { var l = pt(t, RAD - 46); var tx = el('text', { x: l[0], y: l[1] + 4, 'text-anchor': 'middle', class: 'gauge__num' + (t === GAUGE.vLimit && GAUGE.vLimit < GAUGE.vMax ? ' gauge__num--limit' : '') }); tx.textContent = t; }
    }
    var lf = pt(vFull, RAD + 22), lfT = el('text', { x: lf[0], y: lf[1], 'text-anchor': 'middle', class: 'gauge__num', style: 'fill:#3d752f' }); lfT.textContent = fmt(vFull, 1) + ' V';

    var needle = svgG.querySelector('.gauge__needle'), knob = svgG.querySelector('.gauge__knob');
    var valT = svgG.querySelector('.gauge__value');
    var cur = GAUGE.vStart;

    function setV(v) {
      v = Math.round(Math.max(GAUGE.vMin, Math.min(GAUGE.vMax, v)) * 10) / 10;
      cur = v;
      var tip = pt(v, RAD - 34), kn = pt(v, RAD);
      needle.setAttribute('x2', tip[0]); needle.setAttribute('y2', tip[1]);
      knob.setAttribute('cx', kn[0]); knob.setAttribute('cy', kn[1]);
      valT.textContent = fmt(v, 1);
      svgG.setAttribute('aria-valuenow', v); svgG.setAttribute('aria-valuetext', fmt(v, 1) + ' Volt');
      var bad = v > GAUGE.vLimit;
      var p = bad ? 0 : Math.min(GAUGE.pMax, v * GAUGE.iMax);
      gBox.dataset.state = bad ? 'bad' : '';
      gBox.querySelector('[data-g="power"]').textContent = bad ? 'Über ' + GAUGE.vLimit + ' V – nicht zulässig' : '≈ ' + fmt(Math.round(p / 5) * 5, 0) + ' W';
      gBox.querySelector('.gauge__bar span').style.width = (bad ? 100 : p / GAUGE.pMax * 100) + '%';
    }

    // Ziehen mit Maus / Finger
    function fromPointer(e) {
      var r = svgG.getBoundingClientRect(), vb = svgG.viewBox.baseVal;
      var x = (e.clientX - r.left) / r.width * vb.width, y = (e.clientY - r.top) / r.height * vb.height;
      var a = Math.atan2(CY - y, x - CX);
      if (a < 0) a = (x < CX) ? Math.PI : 0;     // unterhalb der Mitte: an den Rand klemmen
      setV(GAUGE.vMin + (1 - a / Math.PI) * (GAUGE.vMax - GAUGE.vMin));
    }
    var dragging = false;
    svgG.addEventListener('pointerdown', function (e) { dragging = true; svgG.setPointerCapture(e.pointerId); fromPointer(e); });
    svgG.addEventListener('pointermove', function (e) { if (dragging) fromPointer(e); });
    svgG.addEventListener('pointerup', function () { dragging = false; });
    svgG.addEventListener('pointercancel', function () { dragging = false; });
    // Tastatur
    svgG.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 1 : 0.1, map = { ArrowRight: step, ArrowUp: step, ArrowLeft: -step, ArrowDown: -step, PageUp: 1, PageDown: -1 };
      if (e.key in map) { e.preventDefault(); setV(cur + map[e.key]); }
      if (e.key === 'Home') { e.preventDefault(); setV(GAUGE.vMin); }
      if (e.key === 'End') { e.preventDefault(); setV(GAUGE.vMax); }
    });
    setV(GAUGE.vStart);
  }

  /* Monatsleiste & Amortisation: Animation beim Sichtbarwerden -------------- */
  document.querySelectorAll('[data-animate]').forEach(function (el) {
    onVisible(el, function () { el.classList.add('is-visible'); });
  });
})();
